import { render, staticRenderFns } from "./SaasBusinessBasicAgreementModal.vue?vue&type=template&id=c4644a58&scoped=true"
import script from "./SaasBusinessBasicAgreementModal.vue?vue&type=script&lang=js"
export * from "./SaasBusinessBasicAgreementModal.vue?vue&type=script&lang=js"
import style0 from "./SaasBusinessBasicAgreementModal.vue?vue&type=style&index=0&id=c4644a58&prod&scoped=true&lang=css"
import style1 from "./SaasBusinessBasicAgreementModal.vue?vue&type=style&index=1&id=c4644a58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4644a58",
  null
  
)

export default component.exports